import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 98.61 14.62"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.93 0c-.99.01-2.01.1-3.07.26-6.04.89-9.4 5.05-8.79 8.65.6 3.51 4.01 5.67 11.45 4.42.17-.03.34-.07.5-.11l1.19-3.25c-.68.29-1.43.53-2.24.69C7.31 11.4 4 10.3 3.58 8.2c-.42-2.1 2.2-4.4 5.86-5.14 2.41-.49 4.67-.17 6.05.7L16.63.63c-1.49-.46-3.05-.65-4.7-.63Zm28.59.49H23.85l-.98 2.68h6.36l-3.66 10.05h3.5l3.66-10.05h4.87l4.54 5.51-1.65 4.54h3.35l1.48-4.06L58.47.49h-5.59L44.64 5.8 40.52.49ZM18.6.5l-4.63 12.73h3.35L21.95.5H18.6Z",
      style: {"fill":"#312d25"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m69.62.5-4.63 12.73h13.97l.98-2.68H69.32l.92-2.52h8.48l.84-2.32h-8.48L72 3.19h15.79l-3.66 10.05h3.5l3.66-10.05h6.36l.98-2.68H69.64Zm-4.95 6.88-3.98 2.47s-.9 1.24-2.95 1.91c-.58.19-1.74.29-2.2.27-1.14-.04-2.22-.3-3.15-.81l-2.32 1.53-.02.02s.03.02.05.03c.99.74 2.14 1.29 3.39 1.58.06.01.11.03.17.04.24.06.49.1.74.13.13.01.25.03.38.04.07 0 .13 0 .2.01.19.01.38.02.57.02.7 0 1.38-.08 2.03-.23.85-.19 1.65-.51 2.39-.92.61-.34 1.18-.75 1.69-1.21 0 0 .02-.01.02-.02.58-.53 1.08-1.13 1.51-1.79.33-.5.6-1.04.82-1.6.36-.77.65-1.46.65-1.46Z",
      style: {"fill":"#9e8165"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M67.66.5h-6.61l-3.89 2.68h6.42l-2.56 5.88 4.01-2.5L67.67.5h-.01Z",
      style: {"fill":"#781520"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "WX-logo"}) } }